import styled from "styled-components/macro";

const CheckboxContainer = styled.div<{ $noMargin?: any }>`
  display: flex;
  flex-direction: row;
  color: ${(props) => props.theme.colors.colorWhite};

  ${({ $noMargin }) =>
    $noMargin ? "" : "margin-bottom: 2rem;\n  margin-left: 2rem;"}
`;

const CheckboxText = styled.p`
  color: ${(props) => props.theme.colors.submitBlue};
  font-size: 14px;
  font-weight: 400;
`;

const Input = styled.input`
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const LabelInput = styled.label<{ checked?: any }>`
  width: 18px;
  height: 18px;
  border-radius: 2px;
  border: solid 2px ${(props) => props.theme.colors.submitBlue};
  margin-right: 1rem;
  color: ${(props) =>
    props.checked
      ? props.theme.colors.submitBlue
      : props.theme.colors.colorWhite};

  &::before {
    display: inline-block;
    content: "✔";
    font-size: 16px;
    line-height: 1;
  }

  &:hover {
    cursor: pointer;
  }
`;

export { CheckboxContainer, CheckboxText, Input, LabelInput };
